export const calculateAge = (dateOfBirth: Date, today: Date) => {
  let age = today.getUTCFullYear() - dateOfBirth.getUTCFullYear();
  const hasNotHadBirthdayYet =
    today.getUTCMonth() < dateOfBirth.getUTCMonth() ||
    (today.getUTCMonth() === dateOfBirth.getUTCMonth() && today.getUTCDate() < dateOfBirth.getUTCDate());

  if (hasNotHadBirthdayYet) {
    age -= 1;
  }

  return age;
};
